/**
 * Thematic Name Generator — generates two-word names for quickplay.
 *
 * Geometry/artillery/void/neon themed: "Neon Prism", "Void Cannon", etc.
 * ~30 adjectives x ~30 nouns = ~900 combinations.
 */

const ADJECTIVES = [
    'Neon', 'Void', 'Crimson', 'Plasma', 'Phantom',
    'Laser', 'Hyper', 'Quantum', 'Turbo', 'Flux',
    'Stellar', 'Radiant', 'Obsidian', 'Blitz', 'Apex',
    'Omega', 'Chrome', 'Primal', 'Surge', 'Molten',
    'Astral', 'Shadow', 'Ultra', 'Volatile', 'Orbital',
    'Rogue', 'Ember', 'Lucid', 'Feral', 'Ionic',
];

const NOUNS = [
    'Prism', 'Cannon', 'Hexagon', 'Mortar', 'Comet',
    'Nova', 'Shard', 'Vortex', 'Titan', 'Bolt',
    'Eclipse', 'Vertex', 'Blaster', 'Specter', 'Pulsar',
    'Fractal', 'Zenith', 'Tempest', 'Forge', 'Cipher',
    'Quasar', 'Reaper', 'Spire', 'Vector', 'Ronin',
    'Phantom', 'Havoc', 'Valkyrie', 'Dagger', 'Orbit',
];

/** Generate a random two-word quickplay name. */
export function generateQuickplayName(): string {
    const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
    const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
    return `${adj} ${noun}`;
}
